import _ from "@lodash";
import dayjs from "dayjs";
import history from "history.js";

export function GetDataAtual(_AValue, _AFormat = "br") {

    var date = new Date();
    var result = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));

    if (_AFormat === "usa") {
        if (_AValue && _AValue !== null) {
            result.setDate(result.getDate() + _AValue);
            return result.toISOString().substring(0, 10);
        }
        else {
            return result.toISOString().substring(0, 10);
        }
    }

    if (_AFormat === "br") {
        if (_AValue && _AValue !== null) {
            result.setDate(result.getDate() + _AValue);
            return result.toISOString().substring(0, 10).split("-")[2] + "/" +
                result.toISOString().substring(0, 10).split("-")[1] + "/" +
                result.toISOString().substring(0, 10).split("-")[0];
        }
        else {
            return result.toISOString().substring(0, 10).split("-")[2] + "/" +
                result.toISOString().substring(0, 10).split("-")[1] + "/" +
                result.toISOString().substring(0, 10).split("-")[0];
        }
    }
}

export function StringDateUSToBR(_AValue) {
    if (!_.isUndefined(_AValue) && !_.isNull(_AValue) && typeof _AValue === "string") {
        return _AValue.substring(0, 10).split("-")[2] + "/" +
            _AValue.substring(0, 10).split("-")[1] + "/" +
            _AValue.substring(0, 10).split("-")[0] + " " +
            _AValue.substr(11, 5);
    }
}

export function GetDataHoraAtual(_AFormat = "br") {

    var date = new Date();
    var result = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));

    if (_AFormat === "usa") {
        return result.toISOString().substring(0, 16).replace("T", " ");
    }

    var a = result.toISOString().substring(0, 10).split("-")[2] + "/" +
        result.toISOString().substring(0, 10).split("-")[1] + "/" +
        result.toISOString().substring(0, 10).split("-")[0] + " " +
        result.toISOString().split("T")[1].substring(0, 5);
    return a;
}

export function GetMeses() {
    return [
        { id: "1", label: "Janeiro" },
        { id: "2", label: "Fevereiro" },
        { id: "3", label: "Março" },
        { id: "4", label: "Abril" },
        { id: "5", label: "Maio" },
        { id: "6", label: "Junho" },
        { id: "7", label: "Julho" },
        { id: "8", label: "Agosto" },
        { id: "9", label: "Setembro" },
        { id: "10", label: "Outubro" },
        { id: "11", label: "Novembro" },
        { id: "12", label: "Dezembro" }
    ];
}

export function GetUFs() {
    return [
        { id: "AC", label: "AC" },
        { id: "AL", label: "AL" },
        { id: "AM", label: "AM" },
        { id: "AP", label: "AP" },
        { id: "BA", label: "BA" },
        { id: "CE", label: "CE" },
        { id: "DF", label: "DF" },
        { id: "ES", label: "ES" },
        { id: "GO", label: "GO" },
        { id: "MA", label: "MA" },
        { id: "MG", label: "MG" },
        { id: "MS", label: "MS" },
        { id: "MT", label: "MT" },
        { id: "PA", label: "PA" },
        { id: "PB", label: "PB" },
        { id: "PE", label: "PE" },
        { id: "PI", label: "PI" },
        { id: "PR", label: "PR" },
        { id: "RJ", label: "RJ" },
        { id: "RN", label: "RN" },
        { id: "RO", label: "RO" },
        { id: "RR", label: "RR" },
        { id: "RS", label: "RS" },
        { id: "SC", label: "SC" },
        { id: "SE", label: "SE" },
        { id: "SP", label: "SP" },
        { id: "TO", label: "TO" }
    ];
}

export function GetAnos() {
    return [
        { id: "1999", label: "1999" },
        { id: "2000", label: "2000" },
        { id: "2001", label: "2001" },
        { id: "2002", label: "2002" },
        { id: "2003", label: "2003" },
        { id: "2004", label: "2004" },
        { id: "2005", label: "2005" },
        { id: "2006", label: "2006" },
        { id: "2007", label: "2007" },
        { id: "2008", label: "2008" },
        { id: "2009", label: "2009" },
        { id: "2010", label: "2010" },
        { id: "2011", label: "2011" },
        { id: "2012", label: "2012" },
        { id: "2013", label: "2013" },
        { id: "2014", label: "2014" },
        { id: "2015", label: "2015" },
        { id: "2016", label: "2016" },
        { id: "2017", label: "2017" },
        { id: "2018", label: "2018" },
        { id: "2019", label: "2019" },
        { id: "2020", label: "2020" },
        { id: "2021", label: "2021" },
        { id: "2022", label: "2022" },
        { id: "2023", label: "2023" },
        { id: "2024", label: "2024" },
        { id: "2025", label: "2025" },
        { id: "2026", label: "2026" },
        { id: "2027", label: "2027" },
        { id: "2028", label: "2028" },
        { id: "2029", label: "2029" },
        { id: "2030", label: "2030" },
        { id: "2031", label: "2031" },
        { id: "2032", label: "2032" },
        { id: "2033", label: "2033" },
        { id: "2034", label: "2034" },
        { id: "2035", label: "2035" },
        { id: "2036", label: "2036" },
        { id: "2037", label: "2037" },
        { id: "2038", label: "2038" },
        { id: "2039", label: "2039" }
    ];
}

export function ParseDate(_AValue) {
    function pad(x) { return ((("" + x).length === 2) ? "" : "0") + x; }
    var m = _AValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        , d = (m) ? new Date(m[3], m[2] - 1, m[1]) : null
        , matchesPadded = (d && (_AValue === [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join("/")))
        , matchesNonPadded = (d && (_AValue === [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/")));
    return (matchesPadded || matchesNonPadded) ? d : null;
}

export function ParseInt(_AValue, _ADefaultValue) {
    var AResponse = _ADefaultValue;
    if (_AValue !== null) {
        if (_AValue.length > 0) {
            if (!isNaN(_AValue)) {
                AResponse = parseInt(_AValue);
            }
        }
    }
    return AResponse;
}

export function GetDataFirstTime(_AFormat) {
    var date = new Date();
    var result = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
    switch (_AFormat) {
        case "usa":
            return (
                result.toISOString().substring(0, 10) + " 00:00:00"
            );
        default:
            return (
                result.toISOString().substring(0, 10).split("-")[2] + "/" +
                result.toISOString().substring(0, 10).split("-")[1] + "/" +
                result.toISOString().substring(0, 10).split("-")[0] + " 00:00:00"
            );
    }
}

export function GetDataLastTime(_AFormat) {
    var date = new Date();
    var result = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
    switch (_AFormat) {
        case "usa":
            return (
                result.toISOString().substring(0, 10) + " 23:59:59"
            );
        default:
            return (
                result.toISOString().substring(0, 10).split("-")[2] + "/" +
                result.toISOString().substring(0, 10).split("-")[1] + "/" +
                result.toISOString().substring(0, 10).split("-")[0] + " 00:00:00"
            );
    }
}

export function SetPreload(_AValue) {
    if (_AValue && _AValue !== null) {
        if (document.getElementById("ContentContainer") !== null &&
            document.getElementById("PreloadContainer") !== null) {
            document.getElementById("ContentContainer").style.display = "none";
            document.getElementById("PreloadContainer").style.display = "flex";
        }
    }
    else {
        if (document.getElementById("ContentContainer") !== null &&
            document.getElementById("PreloadContainer") !== null) {
            document.getElementById("ContentContainer").style.display = "flex";
            document.getElementById("PreloadContainer").style.display = "none";
        }
    }
}

export function GetOrigensPessoa() {
    return [
        { id: 6, label: "Indicação (com cadastro)" },
        { id: 1, label: "Indicação (sem cadastro)" },
        { id: 2, label: "Mídia impressa" },
        { id: 3, label: "Website" },
        { id: 4, label: "E-mail marketing" },
        { id: 5, label: "Outros" }
    ];
}

export function GetDDIPaises() {
    return [
        { "label": "+55", "value": "+55" },
        { "label": "+1", "value": "+1" },
        { "label": "+7", "value": "+7" },
        { "label": "+20", "value": "+20" },
        { "label": "+27", "value": "+27" },
        { "label": "+30", "value": "+30" },
        { "label": "+31", "value": "+31" },
        { "label": "+32", "value": "+32" },
        { "label": "+33", "value": "+33" },
        { "label": "+34", "value": "+34" },
        { "label": "+36", "value": "+36" },
        { "label": "+39", "value": "+39" },
        { "label": "+40", "value": "+40" },
        { "label": "+41", "value": "+41" },
        { "label": "+43", "value": "+43" },
        { "label": "+44", "value": "+44" },
        { "label": "+45", "value": "+45" },
        { "label": "+46", "value": "+46" },
        { "label": "+47", "value": "+47" },
        { "label": "+48", "value": "+48" },
        { "label": "+49", "value": "+49" },
        { "label": "+51", "value": "+51" },
        { "label": "+52", "value": "+52" },
        { "label": "+53", "value": "+53" },
        { "label": "+54", "value": "+54" },
        { "label": "+56", "value": "+56" },
        { "label": "+57", "value": "+57" },
        { "label": "+58", "value": "+58" },
        { "label": "+60", "value": "+60" },
        { "label": "+61", "value": "+61" },
        { "label": "+62", "value": "+62" },
        { "label": "+63", "value": "+63" },
        { "label": "+64", "value": "+64" },
        { "label": "+65", "value": "+65" },
        { "label": "+66", "value": "+66" },
        { "label": "+81", "value": "+81" },
        { "label": "+82", "value": "+82" },
        { "label": "+84", "value": "+84" },
        { "label": "+86", "value": "+86" },
        { "label": "+90", "value": "+90" },
        { "label": "+91", "value": "+91" },
        { "label": "+92", "value": "+92" },
        { "label": "+93", "value": "+93" },
        { "label": "+94", "value": "+94" },
        { "label": "+95", "value": "+95" },
        { "label": "+98", "value": "+98" },
        { "label": "+211", "value": "+211" },
        { "label": "+212", "value": "+212" },
        { "label": "+213", "value": "+213" },
        { "label": "+216", "value": "+216" },
        { "label": "+218", "value": "+218" },
        { "label": "+220", "value": "+220" },
        { "label": "+221", "value": "+221" },
        { "label": "+222", "value": "+222" },
        { "label": "+223", "value": "+223" },
        { "label": "+224", "value": "+224" },
        { "label": "+225", "value": "+225" },
        { "label": "+226", "value": "+226" },
        { "label": "+227", "value": "+227" },
        { "label": "+228", "value": "+228" },
        { "label": "+229", "value": "+229" },
        { "label": "+230", "value": "+230" },
        { "label": "+231", "value": "+231" },
        { "label": "+232", "value": "+232" },
        { "label": "+233", "value": "+233" },
        { "label": "+234", "value": "+234" },
        { "label": "+236", "value": "+236" },
        { "label": "+237", "value": "+237" },
        { "label": "+238", "value": "+238" },
        { "label": "+239", "value": "+239" },
        { "label": "+240", "value": "+240" },
        { "label": "+241", "value": "+241" },
        { "label": "+242", "value": "+242" },
        { "label": "+243", "value": "+243" },
        { "label": "+244", "value": "+244" },
        { "label": "+245", "value": "+245" },
        { "label": "+246", "value": "+246" },
        { "label": "+247", "value": "+247" },
        { "label": "+248", "value": "+248" },
        { "label": "+249", "value": "+249" },
        { "label": "+250", "value": "+250" },
        { "label": "+251", "value": "+251" },
        { "label": "+252", "value": "+252" },
        { "label": "+253", "value": "+253" },
        { "label": "+254", "value": "+254" },
        { "label": "+255", "value": "+255" },
        { "label": "+256", "value": "+256" },
        { "label": "+257", "value": "+257" },
        { "label": "+258", "value": "+258" },
        { "label": "+260", "value": "+260" },
        { "label": "+261", "value": "+261" },
        { "label": "+262", "value": "+262" },
        { "label": "+263", "value": "+263" },
        { "label": "+264", "value": "+264" },
        { "label": "+265", "value": "+265" },
        { "label": "+266", "value": "+266" },
        { "label": "+267", "value": "+267" },
        { "label": "+268", "value": "+268" },
        { "label": "+269", "value": "+269" },
        { "label": "+290", "value": "+290" },
        { "label": "+291", "value": "+291" },
        { "label": "+297", "value": "+297" },
        { "label": "+298", "value": "+298" },
        { "label": "+299", "value": "+299" },
        { "label": "+350", "value": "+350" },
        { "label": "+351", "value": "+351" },
        { "label": "+352", "value": "+352" },
        { "label": "+353", "value": "+353" },
        { "label": "+354", "value": "+354" },
        { "label": "+355", "value": "+355" },
        { "label": "+356", "value": "+356" },
        { "label": "+357", "value": "+357" },
        { "label": "+358", "value": "+358" },
        { "label": "+359", "value": "+359" },
        { "label": "+370", "value": "+370" },
        { "label": "+371", "value": "+371" },
        { "label": "+372", "value": "+372" },
        { "label": "+373", "value": "+373" },
        { "label": "+374", "value": "+374" },
        { "label": "+375", "value": "+375" },
        { "label": "+376", "value": "+376" },
        { "label": "+377", "value": "+377" },
        { "label": "+378", "value": "+378" },
        { "label": "+379", "value": "+379" },
        { "label": "+380", "value": "+380" },
        { "label": "+381", "value": "+381" },
        { "label": "+382", "value": "+382" },
        { "label": "+383", "value": "+383" },
        { "label": "+385", "value": "+385" },
        { "label": "+386", "value": "+386" },
        { "label": "+387", "value": "+387" },
        { "label": "+389", "value": "+389" },
        { "label": "+420", "value": "+420" },
        { "label": "+421", "value": "+421" },
        { "label": "+423", "value": "+423" },
        { "label": "+500", "value": "+500" },
        { "label": "+501", "value": "+501" },
        { "label": "+502", "value": "+502" },
        { "label": "+503", "value": "+503" },
        { "label": "+504", "value": "+504" },
        { "label": "+505", "value": "+505" },
        { "label": "+506", "value": "+506" },
        { "label": "+507", "value": "+507" },
        { "label": "+508", "value": "+508" },
        { "label": "+509", "value": "+509" },
        { "label": "+590", "value": "+590" },
        { "label": "+591", "value": "+591" },
        { "label": "+592", "value": "+592" },
        { "label": "+593", "value": "+593" },
        { "label": "+594", "value": "+594" },
        { "label": "+595", "value": "+595" },
        { "label": "+596", "value": "+596" },
        { "label": "+597", "value": "+597" },
        { "label": "+598", "value": "+598" },
        { "label": "+599", "value": "+599" },
        { "label": "+670", "value": "+670" },
        { "label": "+671", "value": "+671" },
        { "label": "+672", "value": "+672" },
        { "label": "+673", "value": "+673" },
        { "label": "+674", "value": "+674" },
        { "label": "+675", "value": "+675" },
        { "label": "+676", "value": "+676" },
        { "label": "+677", "value": "+677" },
        { "label": "+678", "value": "+678" },
        { "label": "+679", "value": "+679" },
        { "label": "+680", "value": "+680" },
        { "label": "+681", "value": "+681" },
        { "label": "+682", "value": "+682" },
        { "label": "+683", "value": "+683" },
        { "label": "+685", "value": "+685" },
        { "label": "+686", "value": "+686" },
        { "label": "+687", "value": "+687" },
        { "label": "+688", "value": "+688" },
        { "label": "+689", "value": "+689" },
        { "label": "+690", "value": "+690" },
        { "label": "+691", "value": "+691" },
        { "label": "+692", "value": "+692" },
        { "label": "+850", "value": "+850" },
        { "label": "+852", "value": "+852" },
        { "label": "+853", "value": "+853" },
        { "label": "+855", "value": "+855" },
        { "label": "+856", "value": "+856" },
        { "label": "+880", "value": "+880" },
        { "label": "+886", "value": "+886" },
        { "label": "+960", "value": "+960" },
        { "label": "+961", "value": "+961" },
        { "label": "+962", "value": "+962" },
        { "label": "+963", "value": "+963" },
        { "label": "+964", "value": "+964" },
        { "label": "+965", "value": "+965" },
        { "label": "+966", "value": "+966" },
        { "label": "+967", "value": "+967" },
        { "label": "+968", "value": "+968" },
        { "label": "+970", "value": "+970" },
        { "label": "+971", "value": "+971" },
        { "label": "+972", "value": "+972" },
        { "label": "+973", "value": "+973" },
        { "label": "+974", "value": "+974" },
        { "label": "+975", "value": "+975" },
        { "label": "+976", "value": "+976" },
        { "label": "+977", "value": "+977" },
        { "label": "+992", "value": "+992" },
        { "label": "+993", "value": "+993" },
        { "label": "+994", "value": "+994" },
        { "label": "+995", "value": "+995" },
        { "label": "+996", "value": "+996" },
        { "label": "+998", "value": "+998" }
    ];
}

export function GetEspecialidades() {
    return [
        { id: 1, label: "Médico" },
    ];
}

export function GetDataFirstDayMonth(_AFormat, _AData = null) {

    var date = new Date();
    if (!_.isNull(_AData)) {
        var AYear = parseInt(_AData.substring(0, 10).split("-")[0]);
        var AMonth = parseInt(_AData.substring(0, 10).split("-")[1]) - 1;
        var ADay = parseInt(_AData.substring(0, 10).split("-")[2]);
        date = new Date(AYear, AMonth, ADay);
    }

    var result = new Date(date.getFullYear(), date.getMonth(), 1, 3, 0);
    switch (_AFormat) {
        case "usa":
            return (
                result.toISOString().substring(0, 10)
            );
        default:
            return (
                result.toISOString().substring(0, 10).split("-")[2] + "/" +
                result.toISOString().substring(0, 10).split("-")[1] + "/" +
                result.toISOString().substring(0, 10).split("-")[0]
            );
    }
}

export function GetDataLastDayMonth(_AFormat, _AData = null) {
    var date = new Date();
    if (!_.isNull(_AData)) {
        var AYear = parseInt(_AData.substring(0, 10).split("-")[0]);
        var AMonth = parseInt(_AData.substring(0, 10).split("-")[1]) - 1;
        var ADay = parseInt(_AData.substring(0, 10).split("-")[2]);
        date = new Date(AYear, AMonth, ADay);
    }

    var result = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    switch (_AFormat) {
        case "usa":
            return (
                result.toISOString().substring(0, 10)
            );
        default:
            return (
                result.toISOString().substring(0, 10).split("-")[2] + "/" +
                result.toISOString().substring(0, 10).split("-")[1] + "/" +
                result.toISOString().substring(0, 10).split("-")[0]
            );
    }
}

export function GetHorarioAtual() {
    var date = new Date();
    var result = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
    return result.toISOString().substring(11, 16);
}

export function ReplaceAll(_AConteudo, _AStr1, _AStr2, _AIgnore) {
    try {
        return _AConteudo.replaceAll(_AStr1, _AStr2, _AIgnore);
    }
    catch (er) {
        // eslint-disable-next-line no-useless-escape
        return _AConteudo.replace(((typeof (_AStr1) === "string") ? new RegExp(_AStr1.replace(/([\/\,!\\^\${}[]().*\?|\<>-\&])/g, "\$&"), (_AIgnore ? "gi" : "g")) : _AStr1), (typeof (_AStr2) === "string") ? _AStr2.replace(/\$/g, "$$$$") : _AStr2);
    }
}

export function ToLocalISOString(_AData) {
    return _AData.getFullYear() +
        "-" + pad(_AData.getMonth() + 1) +
        "-" + pad(_AData.getDate()) +
        "T" + pad(_AData.getHours()) +
        ":" + pad(_AData.getMinutes()) +
        ":" + pad(_AData.getSeconds()) +
        "." + (_AData.getMilliseconds() / 1000).toFixed(3).slice(2, 5) +
        "Z";
}

export function pad(_ANumber) {
    if (_ANumber < 10) {
        return "0" + _ANumber;
    }
    return _ANumber;
}

export function addDays(_ADate, _ADays) {
    var date = new Date(_ADate.valueOf());
    date.setDate(date.getDate() + _ADays);
    return date;
}

export function addMinutes(_AHour, _AMinutes) {
    var date = new Date("1990-01-01 " + _AHour.valueOf());
    date.setMinutes(date.getMinutes() + _AMinutes);
    return date.toTimeString().split(" ")[0];
}

export function adapterFiltro(_ACondicoes, _AData) {
    var AResponse = [];
    var AOK = true;
    if (!_.isUndefined(_AData) && !_.isNull(_AData)) {
        if (!_.isUndefined(_ACondicoes) && !_.isNull(_ACondicoes)) {
            _AData.forEach(item => {
                AOK = true;
                Object.keys(_ACondicoes).forEach(key => {
                    if (!_ACondicoes[key].includes(item[key])) {
                        AOK = false;
                    }
                });
                if (AOK) {
                    AResponse.push(item);
                }
            });
        }
        else {
            AResponse = _AData;
        }
    }

    return AResponse;
}

export function GetNaturezaTabelaHoras() {
    return [
        { id: 1, label: "Horas normais" },
        { id: 2, label: "Férias" },
        { id: 3, label: "Acordo de compensação" },
        //{ id: 4, label: "Banco de horas" },
        { id: 5, label: "Falta" },
        { id: 6, label: "Hora extra" },
        { id: 7, label: "Atestado Médico" },
        { id: 8, label: "Descanso remunerado" }
    ];
}

export function convertNumToTime(number) {
    // Check sign of given number
    var sign = (number >= 0) ? 1 : -1;

    // Set positive value of number of sign negative
    number = number * sign;

    // Separate the int from the decimal part
    var hour = Math.floor(number);
    var decpart = number - hour;

    var min = 1 / 60;
    // Round to nearest minute
    decpart = min * Math.round(decpart / min);

    var minute = Math.floor(decpart * 60) + "";

    // Add padding if need
    if (minute.length < 2) {
        minute = "0" + minute;
    }

    // Add Sign in final result
    sign = sign == 1 ? "" : "-";

    // Concate hours and minutes
    var time = sign + pad(hour) + ":" + minute;

    return time;
}

export function DateDiffDays(_AData1, _AData2) {
    let date1 = new Date(_AData1);
    let date2 = new Date(_AData2);
    date1 = date1.setHours(0, 0, 0, 0);
    date2 = date2.setHours(0, 0, 0, 0);
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
}

export function DateDiffMinutes(_AData1, _AData2) {
    const date1 = new Date(_AData1);
    const date2 = new Date(_AData2);
    const diffTime = Math.abs(date2 - date1);
    const diffMinutes = Math.ceil(diffTime / (1000 * 60));
    return diffMinutes;
}

export function getAcronimo(_ANome = "") {
    if (_.isNull(_ANome))
        return "";

    _ANome = _ANome.toUpperCase().replace(" DE ", " ").replace(" DA ", " ").replace(" DO ", " ").replace(" DAS ", " ").replace(" DOS ", " ");
    let AResponse = _ANome.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/([^\w]+|\s+)/g, " ");
    return AResponse.split(/\s/).reduce((accumulator, word) => accumulator + word.charAt(0), "").substring(0, 2);
}

export function getLabelIntervaloData(_AInicio, _ATermino, _AIntervalo, _AResumido = false) {
    let dataInicio = new Date((_AInicio + " 00:00:00").replace(/-/g, "/"));
    let dataTermino = new Date((_ATermino + " 00:00:00").replace(/-/g, "/"));
    if ((_.findIndex(GetMeses(), { id: (dataInicio.getMonth() + 1).toString() }) < 0) || (_.findIndex(GetMeses(), { id: (dataTermino.getMonth() + 1).toString() }) < 0)) {
        return "data inválida";
    }
    let MesInicio = _.find(GetMeses(), { id: (dataInicio.getMonth() + 1).toString() }).label;
    let MesTermino = _.find(GetMeses(), { id: (dataTermino.getMonth() + 1).toString() }).label;
    let ASemana = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
    let ASemanaResumida = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

    switch (_AIntervalo) {
        case "month":
            return MesInicio + " " + dataInicio.getFullYear();
        case "week":
            if (_AResumido)
                return dataInicio.getDate() + " " + MesInicio.substring(0, 3) + " - " + dataTermino.getDate() + " " + MesTermino.substring(0, 3);
            else
                return pad(dataInicio.getDate()) + " à " + pad(dataTermino.getDate()) + " de " + MesTermino;
        case "work_week":
            if (_AResumido)
                return dataInicio.getDate() + " " + MesInicio.substring(0, 3) + " - " + dataTermino.getDate() + " " + MesTermino.substring(0, 3);
            else
                return pad(dataInicio.getDate()) + " à " + pad(dataTermino.getDate()) + " de " + MesTermino;
        default:
            if (_AResumido)
                return ASemanaResumida[dataInicio.getDay()] + " " + dataInicio.getDate() + " " + MesInicio.substring(0, 3);
            else
                return ASemana[dataInicio.getDay()] + ", " + pad(dataInicio.getDate()) + " de " + MesInicio;
    }
}

export function getNumberOfWeek(_AData) {
    const today = new Date(_AData);
    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
    const pastDaysOfYear = (today - firstDayOfYear) / 86400000;
    return Math.ceil((pastDaysOfYear + firstDayOfYear.getUTCDay() + 1) / 7);
}

export function getSundayFromWeekNum(weekNum, year) {
    let sunday = new Date(year, 0, (1 + (weekNum - 1) * 7));
    while (sunday.getUTCDay() !== 0) {
        sunday.setDate(sunday.getDate() - 1);
    }
    return sunday;
}

export function isHoje(_AData) {
    let hoje = dayjs(new Date()).format("YYYY-MM-DD");
    let data = dayjs(new Date(_AData)).format("YYYY-MM-DD");
    return (new Date(hoje).getTime() === new Date(data).getTime());
}

export function smartDateFormat(_AData) {
    if (isHoje(_AData)) {
        return dayjs(_AData).format("HH:mm");
    }
    return dayjs(_AData).format("DD/MM/YYYY HH:mm");
}

export function checkPlano(key, settings = null) {
    let plano = {};
    if (!_.isNull(settings) && settings?.planoconfig) {
        plano = settings.planoconfig;
    }
    return plano[key] ?? true;
}

export function checkRouteAuth() {
    const { hostname } = document.location;
    const ADicio = {
        "alpha.hexapp.com.br": "https://app.hexapp.com.br",
        "v1-1.hexapp.com.br": "https://app.hexapp.com.br",
        "v1-2.hexapp.com.br": "https://app.hexapp.com.br",
        "localhost": "http://local.hexapp.com.br:3000"
    };
    if (!_.isUndefined(ADicio[hostname])) {
        return ADicio[hostname];
    }
    return null;
}

export function checkRedirectAuth(_AParametros = "") {
    const { pathname } = document.location;

    const ARoute = checkRouteAuth();
    if (!_.isNull(ARoute)) {
        document.location.href = ARoute + _AParametros;
    }

    if (pathname !== "/pub-login") {
        history.push("/pub-login" + _AParametros);
    }
}

export function diaSemanaToString(_ADia = 0) {
    const ASemana = ["domingo", "segunda", "terca", "quarta", "quinta", "sexta", "sabado"];
    return ASemana[_ADia];
}

export function getMesAno(_AData, _AAbreviado = false) {
    if (_AAbreviado) {
        return dayjs(_AData).format("MMM/YYYY").replace("Feb", "Fev").replace("Apr", "Abr").replace("May", "Mai").replace("Aug", "Ago").replace("Sep", "Set").replace("Oct", "Out").replace("Dec", "Dez");
    }
    else {
        return dayjs(_AData).format("MMMM/YYYY").replace("January", "Janeiro").replace("February", "Fevereiro").replace("March", "Março").replace("April", "Abril").replace("May", "Maio").replace("June", "Junho").replace("July", "Julho").replace("August", "Agosto").replace("September", "Setembro").replace("October", "Outubro").replace("November", "Novembro").replace("December", "Dezembro");
    }
}

export function isSafari() {
    return /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window["safari"] || (typeof safari !== "undefined" && safari.pushNotification));
}

export function generateRange(length, withZero = false) {
    if (withZero) {
        return Array.from(Array(length + 1).keys());
    }
    return Array.from({ length: length }, (_, i) => i + 1);
}